import { rankingData } from '@/mocks/home';

const medalColors = ['text-accent-500', 'text-secondary-400', 'text-primary-600'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-semibold mb-4">
            <i className="ri-bar-chart-grouped-line"></i>
            <span>每30分钟更新一次</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">黑料热度排行榜</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            基于全网搜索量、讨论量与转发量综合计算，最客观的实时热度排名
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {rankingData.map((item, idx) => (
            <a
              key={item.rank}
              href={`#ranking`}
              className={`group flex items-center gap-4 p-4 md:p-5 rounded-xl border transition-all duration-200 cursor-pointer ${item.rank <= 3 ? 'bg-background-100 border-background-200 hover:border-primary-300' : 'bg-background-50 border-background-200/70 hover:border-background-300'}`}
            >
              <div className="flex-shrink-0 w-10 md:w-12 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <i className={`ri-medal-fill text-2xl md:text-3xl ${medalColors[item.rank - 1]}`}></i>
                ) : (
                  <span className="font-heading font-bold text-xl md:text-2xl text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {item.title}
                  </span>
                  <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-secondary-100 text-secondary-700 whitespace-nowrap flex-shrink-0">
                    {item.category}
                  </span>
                </div>
                <div className="flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-fill text-primary-500"></i> {item.heat}
                  </span>
                  <span className={`flex items-center gap-0.5 ${item.trend === 'up' ? 'text-primary-600' : item.trend === 'hot' ? 'text-accent-600' : 'text-secondary-500'}`}>
                    <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : item.trend === 'hot' ? 'ri-fire-fill' : 'ri-arrow-down-line'} text-xs`}></i>
                    {item.change}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>

              <div className="flex-shrink-0 hidden sm:block">
                <span className="font-heading font-bold text-primary-600 text-lg md:text-xl">{item.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}